<!--
 * @Description: 置为无效客户弹窗组件
 * @Author: cxh
 * @Date: 2023-06-25 14:51:13
 * @LastEditTime: 2023-06-30 11:09:19
 * @LastEditors: cxh
-->
<template>
  <cos-modal
    v-model:visible="visible"
    title="置为无效"
    width="670px"
    :confirm-loading="loading"
    @ok="handleBecomeInvalidOk"
  >
    <a-form :model="dataForm" ref="formRef" v-if="visible">
      <a-form-item
        name="cosIdList"
        label="客户名称"
        :rules="{
          message: '请选择',
          required: true
        }"
      >
        <CosSelect
          v-model:value="dataForm.cosIdList"
          :options="selectedData"
          :fieldNames="{ label: 'customerName', value: 'cosId' }"
          mode="multiple"
          :max-tag-count="100"
          disabled
        />
      </a-form-item>
      <a-form-item
        name="invalidId"
        label="无效原因"
        :span="24"
        :rules="{
          message: '请选择',
          validator: selectForNumberValidate,
          required: true
        }"
      >
        <ParamCodesSelect v-model:value="dataForm.invalidId" :options="paramCodeData.lbu_invalid_reason" allowClear />
      </a-form-item>
      <a-form-item
        name="invalidDesc"
        label="说明"
        :rules="{
          message: '请输入',
          required: true
        }"
      >
        <CosTextarea v-model:value="dataForm.invalidDesc" :maxlength="2000" />
      </a-form-item>
    </a-form>
  </cos-modal>
</template>

<script setup lang="ts">
import { ref, onBeforeMount } from 'vue'
import { message as DcMessage } from '@dc-platform/dc-components'
import { selectForNumberValidate } from '@/utils/validate'
import { customerInvalid } from '@/api/yuntuSales/customerCenter'
import { listByParamCodes } from '@/api/common'
import { paramCodesDataFilter } from '@/utils/index'
import type { ParamCodeItem } from '@/typings/common'
import type { PotentialItem } from '@/typings/api/customerCenter'
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const selectedData = ref<PotentialItem[]>([])
const formRef = ref()
const dataForm = ref<any>({})

const paramCodeData = ref<{
  [key: string]: ParamCodeItem[]
}>({
  lbu_invalid_reason: [] // 无效原因
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: ['lbu_invalid_reason']
  }).then((res) => {
    // 递归过滤业务参数状态
    res.data = paramCodesDataFilter(res.data, 0)
    paramCodeData.value = res.data
  })
}
onBeforeMount(() => {
  getByParamCodes()
})

const toggle = (data: PotentialItem[]) => {
  // 仅谈判 10与已注册11状态客户
  if (!data || !data.length) {
    DcMessage.error('请选择数据')
    return
  }
  const errorData = data.find((item: PotentialItem) => item.status !== 10 && item.status !== 11)
  if (errorData) {
    DcMessage.error('仅谈判与已注册状态客户可以提交')
    return
  }
  dataForm.value = {
    cosIdList: data.map((item: PotentialItem) => item.cosId),
    invalidId: undefined,
    invalidDesc: ''
  }
  selectedData.value = data
  visible.value = true
}

const emit = defineEmits(['success'])
const handleBecomeInvalidOk = () => {
  formRef.value?.validate().then(() => {
    loading.value = true
    customerInvalid(dataForm.value)
      .then(() => {
        DcMessage.success('置为无效成功')
        visible.value = false
        emit('success')
      })
      .finally(() => {
        loading.value = false
      })
  })
}
defineExpose({ toggle })
</script>
<script lang="ts">
export default { name: 'BecomeInvalid' }
</script>
